import type {StrategyData} from './types/strategy-data.type';
import {GuidedV2Defaults} from './GuidedV2StrategyService';

export const fallbackStrategiesData: StrategyData = {
  cardType : {
    strategyType: 'cardTypeFallback',
    params: {
      'srt': 'false',
      'imageContain': 'true',
      'rtl': 'false'
    }
  },
  conversationalSearch: {
    strategyType: 'conversationalSearchFallback',
    params: {
      tabsWithConversationalSearch: [],
      isConversationalSearchActive: false,
      conversationalSearchProductsEndpoint: undefined,
      conversationalSearchMedaliaFormId: undefined,
      conversationalSearchBrandUrl: undefined
    }
  },
  dateFormatting: {
    strategyType: 'dateFormattingFallback',
    params: {}
  },
  internalAddresses: {
    strategyType: 'internalAddressesFallback',
    params: {}
  },
  searchers: {
    strategyType: 'searcherNamesFallback',
    params: {}
  },
  baseUrls: {
    strategyType: 'baseUrlsFallback',
    params: {}
  },
  hideLabels: {
    strategyType: 'hideLabelsFallback',
    params: {}
  },
  transformEventsNames: {
    strategyType: 'transformEventsNamesFallback',
    params: {
      fieldsEventMapper: {}
    }
  },
  exstLabels: {
    strategyType: 'exstLabelsFallback',
    params: {labels:[]}
  },
  passFacetInfo:{
    strategyType: 'passFacetInfo',
    params: {
      facetName: '',
    },
  },
  guidedV2:{ /*GuidedV2DefaultStrategyService*/
    strategyType: 'GuidedV2Default',
    params: GuidedV2Defaults,
  },
  queryPrecaching: {
    strategyType: 'precacheFallback',
    params: {}
  },
  tabsType: {
    strategyType: 'tabsFallback',
    params: {
    }
  },
  paginationType: {
    strategyType: 'searchPaginationFallback',
    params: {}
  }
};
